import OffMood from 'assets/images/off_mood.png';
import PlayMood from 'assets/images/play_mood_violet.png';
import PlayMoodPink from 'assets/images/Play-Pink.png';
import PlayMoodCyan from 'assets/images/Play-Cyan.png';
import PlayMoodGreen from 'assets/images/Play-Green.png';
import PlayMoodLightCyan from 'assets/images/Play-lightCyan.png';
import PlayMoodlightGreen from 'assets/images/Play-lightGreen.png';
import useInputKeys from 'hooks/useInputKeys';
import './index.scss';

import { useThemeContext } from 'theme/ThemeContextProvider';

function PlayButton() {
    const {
        play,
        changePlayMood,
        trackFetchingLoading,
    } = useInputKeys();

    const {mode} = useThemeContext();


    const getImageActiveHref = () => {
        return mode === 'light' ? PlayMood
             : mode === 'Cyan' ? PlayMoodCyan
             : mode === 'Green' ? PlayMoodGreen
             : mode === 'Pink' ? PlayMoodPink
             : mode === 'LightCyan' ? PlayMoodLightCyan
             : mode === 'LightGreen' ? PlayMoodlightGreen
             : '';
      };

    return (
        <div className={`play-wrapper ${trackFetchingLoading ? 'loading' : play ? 'play': 'off'}`} onClick={changePlayMood}>
            <img
                src={OffMood}
                alt="Off Mood"
                className="off-mood"
            />
            <img
                src={getImageActiveHref()}
                alt="Play Mood"
                className="play-mood"
            />
        </div>
    );
}

export default PlayButton;
